<template>
  <div class="mb-3">
    <label
      v-if="label"
      :for="id || undefined"
      class="form-label"
    >{{ label }}</label>
    <CFormTextarea
      :id="id || undefined"
      :model-value="currentValue"
      :autocomplete="autocomplete"
      :class="addInputClasses"
      :invalid="!!invalidFeedback"
      :disabled="disabled"
      :readonly="readonly"
      :rows="rows"
      @update:model-value="handleChange"
    />
    <div
      v-if="validFeedback"
      class="valid-feedback d-block"
    >
      {{ validFeedback }}
    </div>
    <div
      v-if="invalidFeedback"
      class="invalid-feedback d-block"
    >
      {{ invalidFeedback }}
    </div>
  </div>
</template>

<script>
import { CFormTextarea } from '@coreui/vue-pro'

export default {
  name: 'CTextarea',
  components: { CFormTextarea },
  props: {
    modelValue: { type: [String, Number], default: '' },
    value: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
    addInputClasses: { type: [String, Object, Array], default: '' },
    invalidFeedback: { type: String, default: '' },
    validFeedback: { type: String, default: '' },
    disabled: Boolean,
    readonly: Boolean,
    rows: { type: [Number, String], default: 3 },
    id: { type: String, default: '' },
    autocomplete: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'update:value', 'input', 'change'],
  computed: {
    currentValue() {
      return this.modelValue !== undefined && this.modelValue !== ''
        ? this.modelValue
        : this.value
    },
  },
  methods: {
    handleChange(val) {
      this.$emit('update:modelValue', val)
      this.$emit('update:value', val)
      this.$emit('input', val)
      this.$emit('change', val)
    },
  },
}
</script>
